'use strict';

export function normalizePhoneNumber(value) {
    value = value.replace(/[\s\.\-]/g, '');
    value = value.replace(/^00/, '+');
    value = value.replace(/^0/, '+33');
    return value;
}

export function validatePhoneNumber(value) {
    return /^\+\d{3,}$/.test(value);
}



// WEBPACK FOOTER //
// ./src/components/form/phone-utils.js